import { useEffect, useRef } from "react";

export function usePollData(fetchData: () => Promise<void>, delay: number) {
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;

        const pollData = async () => {
            while (isMounted.current) {
                try {
                    await fetchData(); // wait for the fetch to finish
                } catch (err) {
                    console.error("Polling error:", err);
                }
                await new Promise((resolve) => setTimeout(resolve, delay)); // wait before next
            }
        };

        pollData();

        return () => {
            isMounted.current = false;
        };
    }, [fetchData, delay]);
}